import {connect} from "react-redux";
import UserInfoSettingsComponent from "./UserInfoSettingsComponent";

const UserInfoSettingsContainer= connect(

)(UserInfoSettingsComponent);

export default UserInfoSettingsComponent;

